<script lang="ts">
  import type { IconNames } from '@shared/ui/icon';
  import { Tooltip } from '@shared/ui/tooltip';

  export let iconName: IconNames | undefined = 'four-pointed-star';
  export let classes: string | undefined = undefined;
</script>

<Tooltip {iconName} tooltipClasses="min-w-64" contentWrapperClasses="{classes}">
  This means that our curator carefully selected and studied the artwork, providing you the deeper context from a
  professional perspective.
</Tooltip>
